import { updateState } from '@fil-global/eiswagen';

import {
  BLANK,
  CANCELINVITATION_FAILURE,
  CANCELINVITATION_REQUEST,
  CANCELINVITATION_RESET,
  CANCELINVITATION_SUCCESS,
  CLEAR_CANCELINVITATION,
  CLEAR_DELETE_INVESTOR,
  CLEAR_GENECODE,
  CLEAR_RESENDSERID,
  DELETE_INVESTOR_FAILURE,
  DELETE_INVESTOR_REQUEST,
  DELETE_INVESTOR_RESET,
  DELETE_INVESTOR_SUCCESS,
  DOWNLOAD_FILE_FAILED,
  DOWNLOAD_FILE_FALSE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_TRUE,
  GENERATECODE_FAILURE,
  GENERATECODE_REQUEST,
  GENERATECODE_RESET,
  GENERATECODE_SUCCESS,
  INVITE_COUNTRY_CODE_FAILURE,
  INVITE_COUNTRY_CODE_REQUEST,
  INVITE_COUNTRY_CODE_SUCCESS,
  PERMISSION_FAILURE,
  PERMISSION_REQUEST,
  PERMISSION_RESET,
  PERMISSION_SUCCESS,
  SENDINVITATION_FAILURE,
  SENDINVITATION_REQUEST,
  SENDINVITATION_RESET,
  SENDINVITATION_SUCCESS,
  SHOW_DOWNLOAD_FILE_NOTI_FALSE,
  SHOW_DOWNLOAD_FILE_NOTI_TRUE,
  USER_LIST_DELETE_NOTIFICATION,
  USER_REPORT_INFO_FAILURE,
  USER_REPORT_INFO_REQUEST,
  USER_REPORT_INFO_RESET,
  USER_REPORT_INFO_SUCCESS,
  USERDETAIL_CLEAR_RESENDSERID,
  USERDETAIL_INITIAL,
  USERLIST_CLEAR_SEARCH_DATA,
  USERLIST_FAILURE,
  USERLIST_REQUEST,
  USERLIST_SAVE_SEARCH_DATA,
  USERLIST_SUCCESS,
} from './constants';

const initialState = {
  isRequest: false,
  isSendInvition: false,
  isGenerateCode: false,
  isCancelInvition: false,
  error: null,
  permission: null,
  isUserlistRequest: false,
  userlist: null,
  resendInvitationSuccess: false,
  resendUserId: null,
  generateCode: null,
  generateCodeError: null,
  generateCodeSuccess: false,
  userReportInfo: null,
  isReportRequest: false,
  isDownloadFile: false,
  exportNotification: false,
  showDownloadNoti: false,
  errorType: 0,
  cancelInvitationSuccess: false,
  cancelInvitationError: false,
  deleteInvestorSuccess: false,
  deleteInvestorError: null,
  searchData: {},
  countryCodes: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PERMISSION_REQUEST:
      return updateState(state, {
        isRequest: true,
        error: null,
      });
    case PERMISSION_SUCCESS:
      return updateState(state, {
        isRequest: false,
        permission: action.data,
      });
    case PERMISSION_FAILURE:
      return updateState(state, {
        isRequest: false,
        error: action.error,
      });
    case PERMISSION_RESET:
      return updateState(state, {
        isRequest: false,
        error: null,
        permission: null,
      });
    case USERLIST_REQUEST:
      return updateState(state, {
        isUserlistRequest: true,
        userlist: null,
        error: null,
      });
    case USERLIST_SUCCESS:
      return updateState(state, {
        isUserlistRequest: false,
        userlist: action.data.userList,
      });
    case USERLIST_FAILURE:
      return updateState(state, {
        isUserlistRequest: false,
        error: action.error,
      });
    case GENERATECODE_REQUEST:
      return updateState(state, {
        isGenerateCode: true,
        generateCode: null,
        generateCodeError: null,
        generateCodeSuccess: false,
      });
    case GENERATECODE_SUCCESS:
      return updateState(state, {
        isGenerateCode: false,
        generateCode: { ...action.data },
        generateCodeSuccess: true,
      });
    case GENERATECODE_FAILURE:
      return updateState(state, {
        isGenerateCode: false,
        generateCode: { ...action.data },
        generateCodeError: action.error,
        generateCodeSuccess: false,
      });
    case GENERATECODE_RESET:
      return updateState(state, {
        isGenerateCode: false,
        generateCodeSuccess: false,
        generateCode: null,
      });
    case SENDINVITATION_REQUEST:
      return updateState(state, {
        isSendInvition: true,
        resendInvitationError: null,
      });
    case SENDINVITATION_SUCCESS:
      return updateState(state, {
        isSendInvition: false,
        resendInvitation: action.data.message,
        resendUserId: action.data.id,
        resendInvitationSuccess: true,
        resendInvitationError: null,
      });
    case SENDINVITATION_FAILURE:
      return updateState(state, {
        isSendInvition: false,
        generateCode: null,
        resendInvitationError: action.error,
        resendInvitationSuccess: false,
      });
    case SENDINVITATION_RESET:
      return updateState(state, {
        isSendInvition: false,
        resendInvitation: null,
        resendUserId: null,
        resendInvitationError: null,
        resendInvitationSuccess: false,
      });

    case USER_REPORT_INFO_REQUEST:
      return updateState(state, {
        isReportRequest: true,
        error: null,
      });
    case USER_REPORT_INFO_SUCCESS:
      return updateState(state, {
        isReportRequest: false,
        userReportInfo: action.data,
      });
    case USER_REPORT_INFO_FAILURE:
      return updateState(state, {
        isReportRequest: false,
        error: action.error,
      });
    case USER_REPORT_INFO_RESET:
      return updateState(state, {
        isReportRequest: false,
        error: null,
        userReportInfo: null,
      });

    case USERDETAIL_INITIAL:
      return updateState(state, {
        isSendInvition: false,
        isGenerateCode: false,
        resendInvitation: null,
        resendInvitationError: null,
        resendInvitationSuccess: false,
        generateCode: null,
        generateCodeError: null,
        generateCodeSuccess: false,
      });
    case USERDETAIL_CLEAR_RESENDSERID:
      return updateState(state, {
        resendUserId: null,
      });
    case CLEAR_GENECODE:
      return updateState(state, {
        generateCode: null,
        generateCodeError: null,
        generateCodeSuccess: false,
      });
    case CLEAR_RESENDSERID:
      return updateState(state, {
        resendInvitation: null,
        resendInvitationError: null,
        resendInvitationSuccess: false,
      });
    case DOWNLOAD_FILE_FALSE:
      return updateState(state, {
        isDownloadFile: false,
      });
    case DOWNLOAD_FILE_TRUE:
      return updateState(state, {
        isDownloadFile: true,
      });
    case DOWNLOAD_FILE_FAILED:
      return updateState(state, {
        exportNotification: true,
        errorType: action.data,
      });
    case DOWNLOAD_FILE_SUCCESS:
      return updateState(state, {
        exportNotification: false,
      });
    case SHOW_DOWNLOAD_FILE_NOTI_FALSE:
      return updateState(state, {
        showDownloadNoti: false,
      });

    case SHOW_DOWNLOAD_FILE_NOTI_TRUE:
      return updateState(state, {
        showDownloadNoti: true,
      });
    case CANCELINVITATION_REQUEST:
      return updateState(state, {
        isCancelInvition: true,
        cancelInvitationError: null,
      });
    case CANCELINVITATION_SUCCESS:
      return updateState(state, {
        isCancelInvition: false,
        cancelInvitation: action.data.message,
        cancelUserId: action.data.id,
        cancelInvitationSuccess: true,
        cancelInvitationError: null,
      });
    case CANCELINVITATION_FAILURE:
      return updateState(state, {
        isCancelInvition: false,
        generateCode: null,
        cancelInvitationError: action.error,
        cancelInvitationSuccess: false,
      });
    case CANCELINVITATION_RESET:
      return updateState(state, {
        isCancelInvition: false,
        cancelInvitation: null,
        cancelUserId: null,
        cancelInvitationError: null,
        cancelInvitationSuccess: false,
      });
    case CLEAR_CANCELINVITATION:
      return updateState(state, {
        cancelInvitation: null,
        cancelInvitationError: null,
        cancelInvitationSuccess: false,
      });
    case DELETE_INVESTOR_REQUEST:
      return updateState(state, {
        isDeleteInvestor: true,
        deleteInvestorSuccess: false,
        deleteInvestorError: null,
      });
    case DELETE_INVESTOR_SUCCESS:
      return updateState(state, {
        isDeleteInvestor: false,
        deleteInvestorResult: action.data.message,
        investorId: action.data.id,
        deleteInvestorSuccess: true,
        deleteInvestorError: null,
      });
    case DELETE_INVESTOR_FAILURE:
      return updateState(state, {
        isDeleteInvestor: false,
        deleteInvestorSuccess: false,
        deleteInvestorError: action.error,
      });
    case DELETE_INVESTOR_RESET:
      return updateState(state, {
        isDeleteInvestor: false,
        deleteInvestorResult: null,
        investorId: null,
        deleteInvestorSuccess: false,
        deleteInvestorError: null,
      });
    case CLEAR_DELETE_INVESTOR:
      return updateState(state, {
        deleteInvestorResult: null,
        deleteInvestorSuccess: false,
        deleteInvestorError: null,
      });
    case USER_LIST_DELETE_NOTIFICATION:
      return updateState(state, {
        userListDeleteNotificationFlag: action.flag,
      });
    case USERLIST_CLEAR_SEARCH_DATA:
      return updateState(state, {
        searchData: {},
      });
    case USERLIST_SAVE_SEARCH_DATA:
      return updateState(state, {
        searchData: action.data.searchData,
      });
    case INVITE_COUNTRY_CODE_REQUEST:
      return updateState(state, {
        isRequest: true,
        countryCodes: null,
      });
    case INVITE_COUNTRY_CODE_SUCCESS:
      return updateState(state, {
        isRequest: false,
        countryCodes: action.data.countryCodes,
      });
    case INVITE_COUNTRY_CODE_FAILURE:
      return updateState(state, {
        isRequest: false,
        countryCodes: null,
      });
    case BLANK:
    default:
      return state;
  }
};
